// ── BIDashboardPage ──
import { Card, ErrorMsg } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

export const BIDashboardPage = ({ id }) => {
    const { biDashboards } = useApp();
    const d = biDashboards.find(x => x.id === id);
    if (!d) return <Card><ErrorMsg msg="Dashboard not found." /></Card>;
    return (
      <div style={{ height: "calc(100vh - 140px)" }}>
        <iframe
          title={d.name}
          src={d.embedurl}
          style={{ width: "100%", height: "100%", border: "none" }}
          allowFullScreen
        />
      </div>
    );
  };
